<script setup lang="ts">
import { defineEmits, defineProps } from 'vue'
import CardComponent from '@/components/ui/CardComponent.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n()

defineProps({
  title: {
    type: String,
    default: ''
  },
  message: {
    type: String,
    default: ''
  },
  validateButton: {
    type: String,
    default: ''
  },
  cancelButton: {
    type: String,
    default: ''
  }
})

const emits = defineEmits(['closeModal'])
</script>

<template>
  <CardComponent with-actions>
    <template #title>
      {{ title }}
    </template>
    <template #item>
      {{ message }}
    </template>
    <template #actions>
      <v-btn variant="outlined" @click="emits('closeModal', false)">
        {{ cancelButton || t('common.buttons.cancel') }}
      </v-btn>
      <v-btn
        color="primary"
        type="submit"
        variant="flat"
        @click="emits('closeModal', true)">
        {{ validateButton || t('common.buttons.validate') }}
      </v-btn>
    </template>
  </CardComponent>
</template>
